export enum MaterialType {
    EXTERIOR,
    CARCASE,
}
